export default __webpack_public_path__ + "static/media/last-frame.3588f300.png";